import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));

//const isPWA = window.matchMedia('(display-mode: standalone)').matches;
const token = localStorage.getItem('token');
const currentPath = window.location.pathname.substring(1);

const knownRoutes = ['waitingasset', 'call'];
const isToken = !knownRoutes.includes(currentPath.toLowerCase()) && currentPath != '';

if (token != null && (currentPath !== token && !isToken)) {
  window.location.href = `/${token}`;
}
